const DATE_RANGE_OFFSET_DAYS = 14;
const MIN_DATE_YEAR = 1000;

export function createDefaultDateRange(now = new Date()) {
  const startDate = new Date(now);
  startDate.setDate(startDate.getDate() - DATE_RANGE_OFFSET_DAYS);

  const endDate = new Date(now);
  endDate.setDate(endDate.getDate() + DATE_RANGE_OFFSET_DAYS);

  return {
    startDate,
    endDate,
    key: 'selection',
  };
}

function parseStoredDate(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const timestamp = Number(value);
  if (!Number.isFinite(timestamp)) {
    return null;
  }

  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) || date.getFullYear() < MIN_DATE_YEAR ? null : date;
}

function getStorage(storage) {
  if (storage !== undefined) {
    return storage;
  }

  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch (error) {
    return null;
  }
}

export function loadManageJobDateRange(storage, now = new Date()) {
  const fallback = createDefaultDateRange(now);
  const targetStorage = getStorage(storage);

  if (!targetStorage) {
    return fallback;
  }

  try {
    const startDate = parseStoredDate(targetStorage.getItem('startDate'));
    const endDate = parseStoredDate(targetStorage.getItem('endDate'));

    if (startDate && endDate && startDate.getTime() <= endDate.getTime()) {
      return {
        startDate,
        endDate,
        key: 'selection',
      };
    }
  } catch (error) {
    // Storage can be unavailable in private browsing or when disabled.
  }

  return fallback;
}

export function persistManageJobDateRange(range, storage) {
  const targetStorage = getStorage(storage);
  if (!targetStorage || !range?.startDate || !range?.endDate) {
    return;
  }

  try {
    targetStorage.setItem('startDate', String(range.startDate.getTime()));
    targetStorage.setItem('endDate', String(range.endDate.getTime()));
  } catch (error) {
    // Storage can be unavailable in private browsing or when disabled.
  }
}
